import React from "react";
import Cell from "../Cell";
import ModuleExpoDialog from "../ModuleExpoDialog";
import FillersDialog from "../FillersDialog";
import { isMobileOnly } from "react-device-detect";
import ModuleExpoOverrides from "../ModuleExpoOverrides";
import SectionFillerOverrides from "../SectionFillerOverrides";

const fillerSides = ["left", "right", "top", "bottom", "back"];

const FillerCell = ({
  type,
  rowId,
  tempId,
  isFiller,
  propertyList,
  sides,
  tableManager,
  dialogProps,
  sectionId,
  errorMessage,
  selectionManager,
  pasteOverrides,
  blurred,
  onContextMenu,
  viewMode,
}) => {
  const renderContent = () => {
    const sectionFillerSides =
      pasteOverrides && type === "section" ? pasteOverrides.sides : sides;
    if (tempId) return null;

    if (type === "module") {
      return (
        <div className="d-flex align-items-center column-gap-1">
          {fillerSides.map((side, index) => {
            const property = propertyList?.find(
              (e) => e.identifier === `exposed_side_${side}`
            );
            if (!property) return null;

            let selected;
            if (pasteOverrides) {
              const overrideKey = `exposed_side_${side}`;
              selected = pasteOverrides[overrideKey]?.endsWith("_true");
            } else {
              selected = property.options.find(
                (e) => e.identifier === `exposed_side_${side}_true`
              )?.selected;
            }

            return (
              selected && (
                <div
                  key={index}
                  className="rounded-circle px-1 border-secondary border text-capitalize"
                >
                  {side[0]}
                </div>
              )
            );
          })}
        </div>
      );
    }

    // For section
    return (
      <div className="px-1 text-secondary justify-content-center align-content-center">
        <div className="flex flex-row">
          {fillerSides.map(
            (side, index) =>
              sectionFillerSides?.[side]?.type !== "none" && (
                <div
                  key={index}
                  className="rounded-circle px-1 border-secondary border-1 border ms-1"
                >
                  {side[0].toUpperCase()}
                </div>
              )
          )}
        </div>
      </div>
    );
  };

  const getExpoModuleOverrides = (propertyList) => {
    const selectedSides = [];
    const selectedColors = [];

    ["left", "right", "top", "bottom", "back"].forEach((side) => {
      const property = propertyList?.find(
        (e) => e.identifier === `exposed_side_${side}`
      );

      if (!property) return;

      const selectedOption = property.options.find(
        (e) => e.identifier === `exposed_side_${side}_true`
      );

      if (selectedOption?.selected) {
        selectedSides.push(side);

        const colorProperty = propertyList.find(
          (e) => e.identifier === `${side}_expo_color`
        );

        const selectedColorOption = colorProperty?.options.find(
          (option) => option.selected
        );

        selectedColors.push(selectedColorOption || null);
      }
    });

    return { selectedSides, selectedColors };
  };

  const expoModuleOverrides = getExpoModuleOverrides(propertyList);

  const noOverridesAndNoneType = ["left", "right", "top", "bottom"].every(
    (direction) => {
      const side = sides?.[direction];
      const overridesEmpty =
        !side?.overrides || Object.keys(side.overrides).length === 0;
      const typeIsNone = side?.type === "none";
      return overridesEmpty && typeIsNone;
    }
  );

  const anyFillerOverrides = () => {
    return ["left", "right", "top", "bottom"].some(
      (direction) => sides[direction].type !== "none"
    );
  };

  return (
    <Cell
      rowType={type}
      rowId={rowId}
      column="filler"
      status="focus"
      className={
        type === "module"
          ? "px-3 justify-content-center"
          : "d-flex flex-grow-0 flex-shrink-0 align-items-center column-gap-3 justify-content-center align-items-center position-relative px-2"
      }
      customStyles={{ width: isMobileOnly ? "13%" : "75px" }}
      tableManager={tableManager}
      isTemp={tempId}
      isFillerRow={isFiller}
      errorMessage={errorMessage}
      sectionId={sectionId}
      selectionManager={selectionManager}
      blurred={blurred}
      onContextMenu={onContextMenu}
      hoverComponent={
        type === "module" &&
        expoModuleOverrides &&
        expoModuleOverrides.selectedSides?.length &&
        !tableManager.isActive(type, rowId, "filler") ? (
          <ModuleExpoOverrides expoModuleOverrides={expoModuleOverrides} />
        ) : type === "section" &&
          !tableManager.isActive(type, rowId, "filler") &&
          sides &&
          anyFillerOverrides() ? (
          <SectionFillerOverrides group={selectionManager.findGroup(rowId)} />
        ) : null
      }
      hasExpo={
        type === "module" &&
        (!expoModuleOverrides || !expoModuleOverrides.selectedSides?.length)
      }
      hasFiller={type === "section" && sides && noOverridesAndNoneType}
    >
      {renderContent()}

      {tableManager.isActive(type, rowId, "filler") &&
        viewMode !== "review" &&
        (type === "module" ? (
          <ModuleExpoDialog
            end={viewMode === "default" ? "false" : "true"}
            {...dialogProps}
          />
        ) : (
          <FillersDialog
            end={viewMode === "default" ? "false" : "true"}
            {...dialogProps}
          />
        ))}
    </Cell>
  );
};

export default FillerCell;
